import React, { useState } from 'react';
import { Youtube, Linkedin, Twitter, Instagram, Mail, Send } from 'lucide-react';
import { socialStats } from '../data/mock';

const iconMap = {
  Youtube: Youtube,
  Linkedin: Linkedin,
  Twitter: Twitter,
  Instagram: Instagram
};

const SocialProofSection = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Mock newsletter subscription
    console.log('Newsletter subscription:', email);
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setEmail('');
    }, 3000);
  };

  return (
    <section className="pt-4 pb-20 bg-gray-50">
      <div className="container">
        <div className="text-center">
          <h2 className="heading-large text-gray-900 mb-8">
            Follow Us
          </h2>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
            {socialStats.map((stat, index) => {
              const IconComponent = iconMap[stat.icon];
              
              return (
                <a 
                  key={index}
                  href={stat.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex flex-col items-center p-6 bg-white rounded-xl hover:bg-blue-50 transition-colors duration-200 hover-lift cursor-pointer border border-blue-100"
                >
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-teal-500 rounded-full flex items-center justify-center mb-4">
                    <IconComponent className="text-white" size={24} />
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-gray-900">
                      {stat.count}
                    </div>
                    <div className="text-gray-600 body-small">
                      {stat.platform}
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;